const prefix = '@page';

export const FETCH_REQUEST = `${prefix}/FETCH_REQUEST`;
export const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;
export const FETCH_FAILURE = `${prefix}/FETCH_FAILURE`;

export const FETCH_COMPOSITE_DETAIL_REQUEST = `${prefix}/FETCH_COMPOSITE_DETAIL_REQUEST`;
export const FETCH_COMPOSITE_DETAIL_SUCCESS = `${prefix}/FETCH_COMPOSITE_DETAIL_SUCCESS`;
export const FETCH_COMPOSITE_DETAIL_FAILURE = `${prefix}/FETCH_COMPOSITE_DETAIL_FAILURE`;

export const FETCH_COMPOSITE_LIST_REQUEST = `${prefix}/FETCH_COMPOSITE_LIST_REQUEST`;
export const FETCH_COMPOSITE_LIST_SUCCESS = `${prefix}/FETCH_COMPOSITE_LIST_SUCCESS`;
export const FETCH_COMPOSITE_LIST_FAILURE = `${prefix}/FETCH_COMPOSITE_LIST_FAILURE`;

export const SEPARATE_BLOG_PAGES = `${prefix}/SEPARATE_BLOG_PAGES`;
